import { request } from './client'

export type Scope = 'read_only' | 'full'
export type CreatedToken = { id: string; token: string; scope: Scope; expires_at: string }
export type TokenSummary = {
  id: string
  label: string
  scope: Scope
  created_at: string
  expires_at: string
  last_used_at: string | null
}

export const EXPIRY_OPTIONS: { label: string; seconds: number }[] = [
  { label: '30 minutes', seconds: 1800 },
  { label: '1 hour', seconds: 3600 },
  { label: '2 hours', seconds: 7200 },
  { label: '4 hours', seconds: 14400 },
  { label: '8 hours', seconds: 28800 },
  { label: '24 hours', seconds: 86400 },
  { label: '7 days', seconds: 604800 },
  { label: '30 days', seconds: 2592000 },
]

// The endpoints are mounted at /api/v1/auth/agent-tokens. The shared `request`
// client prefixes API_BASE ('/api') automatically and sets Content-Type +
// credentials, so callers pass only the /v1/... path, method, and body.
export async function createToken(body: { label: string; scope: Scope; ttl_seconds: number }) {
  return request<CreatedToken>('/v1/auth/agent-tokens', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export async function listTokens() {
  return request<TokenSummary[]>('/v1/auth/agent-tokens')
}

export async function revokeToken(id: string) {
  return request<void>(`/v1/auth/agent-tokens/${id}`, { method: 'DELETE' })
}
